

export class Png {

    public static async fromUrl(url: string) {

        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        const img = new Image();
        img.crossOrigin = 'anonymous';

        return new Promise<Png>((rs, rj) => {
            img.onload = () => {
                canvas.width = img.width;
                canvas.height = img.height;
                ctx?.drawImage(img, 0, 0);
                rs(new Png(canvas.width, canvas.height, canvas));
            };
            img.onerror = () => {
                rj(new Error('Failed to load image'));
            };
            img.src = url;
        });
    }

    public static async fromSvg(svg: string) {

        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        const img = new Image();

        // Need to convert SVG string to data URL
        const svgBlob = new Blob([svg], { type: 'image/svg+xml' });
        const svgUrl = URL.createObjectURL(svgBlob);

        return new Promise<Png>((rs, rj) => {
            img.onload = () => {
                canvas.width = img.width;
                canvas.height = img.height;
                ctx?.drawImage(img, 0, 0);
                URL.revokeObjectURL(svgUrl);
                rs(new Png(canvas.width, canvas.height, canvas));
            };
            img.onerror = () => {
                URL.revokeObjectURL(svgUrl);
                rj(new Error('Failed to load SVG'));
            };
            img.src = svgUrl;
        });
    }

    constructor(public width: number, public height: number, public source: HTMLCanvasElement) {
    }

    public toDataURL() {
        return this.source.toDataURL();
    }

    public async toBlob() {
        return new Promise<Blob>((rs, rj) => {
            this.source.toBlob((blob) => {
                if (blob) rs(blob);
                else rj(new Error('Failed to convert to blob'));
            });
        });
    }
}
